export default __webpack_public_path__ + "static/media/09_UNEASY.415f7e42.png";